import { Order, OrderStatus } from "@/types";
import { Badge } from "rizzui";

const data = [
    {
        Agency: "Deprixa Miami",
        Office: "Miami - Florida",
        "Logistics Service": "Ocean Freight",
    },
    {
        "Billing date": "Jun 15, 2023",
        "Package Type": "Flat small box",
        "Courier Company": "Cargus",
    },
    {
        "Delivery time": "TNT 10-14 DAYS",
        "Payment Method": "Cash on delivery",
        "Shipping Mode": "Next Day",
    },
];

interface OrderDetailsProps {
    order: Order;
}

export default function DetailsSection({ order }: OrderDetailsProps) {
    const data = [
        {
            "Product Name": order?.product?.name,
            Category: order?.product?.category?.name,
            Supplier: order?.product?.supplier,
        },
        {
            Weight: `${order?.product?.weight} kg`,
            Quantity: order?.quantity,
            "Delivery Address": order?.shippingAddress,
        },
        {
            "Tracking Number": order?.trackingNumber,
            "Total Price": `$${order?.totalPrice}`,
            "Purchase Date": new Date(order?.createdDate).toLocaleDateString(),
        },
    ];
    return (
        <div className="grid items-start rounded-xl border border-gray-300 p-5 @2xl:grid-cols-2 @3xl:grid-cols-3 @3xl:p-8 @5xl:grid-cols-4">
            <ul className="grid gap-3 @3xl:col-span-full @3xl:mb-2 @5xl:col-span-1 @5xl:mb-0">
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Order No :
                    </span>
                    <span className="text-base font-semibold text-gray-900">
                        #{order.orderId}
                    </span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Tracking Number :
                    </span>
                    <span>{order.trackingNumber || "Not Available"}</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Status :
                    </span>
                    {order.status === OrderStatus.Delivered ? (
                        <Badge color="success" variant="flat" rounded="md">
                            {order.status}
                        </Badge>
                    ) : order.status === OrderStatus.Requested ? (
                        <Badge color="warning" variant="flat" rounded="md">
                            {order.status}
                        </Badge>
                    ) : order.status === OrderStatus.Cancelled ? (
                        <Badge color="danger" variant="flat" rounded="md">
                            {order.status}
                        </Badge>
                    ) : order.status === OrderStatus.Processing ? (
                        <Badge color="secondary" variant="flat" rounded="md">
                            {order.status}
                        </Badge>
                    ) : order.status === OrderStatus.Purchased ? (
                        <Badge color="primary" variant="flat" rounded="md">
                            {order.status}
                        </Badge>
                    ) : order.status === OrderStatus.InTransit ? (
                        <Badge color="info" variant="flat" rounded="md">
                            {order.status}
                        </Badge>
                    ) : null}
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Order Date :
                    </span>
                    <span>
                        {new Date(order.createdDate).toLocaleDateString()}
                    </span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">Country</span>
                    <span>{order.country}</span>
                </li>
            </ul>
            <ul className="mt-3 grid gap-3 @5xl:mt-0">
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Product Name :
                    </span>
                    <span>{order.product?.name || "Not Available"}</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Category :
                    </span>
                    <span>
                        {order.product?.category?.name || "Not Available"}
                    </span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Supplier :
                    </span>
                    <span>{order.product?.supplier || "Not Available"}</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Weight :
                    </span>
                    <span>{order.product?.weight} kg</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Quantity :
                    </span>
                    <span>{order.quantity}</span>
                </li>
            </ul>
            <ul className="mt-3 grid gap-3 @5xl:mt-0">
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Shipping Provider :
                    </span>
                    <span>{order?.shipmentProvider || "Not available"}</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Delivery Address :
                    </span>
                    <span>{order.shippingAddress}</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Cubic Meter :
                    </span>
                    <span>${order.product?.cubicMeter}</span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Shipping Cost :
                    </span>
                    <span>
                        {order.shippingCost
                            ? `$${order.shippingCost}`
                            : "Not Available"}
                    </span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Shipping Date :
                    </span>
                    <span>
                        {order.shippingDate
                            ? new Date(
                                  order.actualDeliveryDate,
                              ).toLocaleDateString()
                            : "Not Available"}
                    </span>
                </li>
            </ul>
            <ul className="mt-3 grid gap-3 @5xl:mt-0 ml-5">
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Unit Price :
                    </span>
                    <span>
                        {order.product?.price
                            ? `$${order.product.price}`
                            : "Not Available"}
                    </span>
                </li>
                <li className="flex items-center gap-3 @3xl:justify-between @5xl:justify-start">
                    <span className="font-semibold text-gray-900">
                        Total Price :
                    </span>
                    <span className="text-base font-semibold text-green-800">
                        ${order.totalPrice}
                    </span>
                </li>
            </ul>
            {/* {data.map((item, index) => (
                <ul key={index} className="mt-3 grid gap-3 @5xl:mt-0">
                    {Object.entries(item).map(([key, value]) => (
                        <li key={key} className="flex items-center gap-3">
                            <span className="font-semibold text-gray-900">
                                {key} :
                            </span>
                            <span>{value}</span>
                        </li>
                    ))}
                </ul>
            ))} */}
        </div>
    );
}
